// internal-deps
import { VALID_PAYMENT_METHODS } from "@swiggy-private/payment-types";

// interfaces
import { CodPaymentMethodData, PaymentMethodDef } from "@payment-ui/interfaces";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// helpers
import { getPaymentMethodPromoMsg, getPaymentMethodDisableMsg } from "@payment-ui/helpers/Payment";

export const getCodAriaLabel = (paymentMethodData: CodPaymentMethodData, enabled: boolean): string => {
    const displayName = TEXTS.CASH;
    if (!enabled) {
        return `${displayName} ${getPaymentMethodDisableMsg(paymentMethodData)}`;
    }
    return `${displayName} ${getPaymentMethodPromoMsg(paymentMethodData)}`;
};

// this function will replace $amount placeholder (coming from backend) to the actual amount
export const replaceAmount = (ctaMsg: string, amount: string): string => {
    return ctaMsg.replace(TEXTS.AMOUNT, amount);
};

export const isCODPaymentMethod = (method: PaymentMethodDef): method is CodPaymentMethodData => {
    return VALID_PAYMENT_METHODS.COD === method.name.toUpperCase();
};
